import React from 'react'

export default function (propriedades) {
  return (
    <div>
      <header className='header--startse'>
        <img src='https://storage.googleapis.com/images.evnts.rocks/img/eventos/logo-startse.png' alt={`Logo`} />
      </header>
    </div>
  )
}
